export default "__VITE_ASSET__DcQAUIqF__"